import axios from "axios";
import { UserSession } from "../user_session";
import * as Vars from "./Vars";

export class Projects {

  /**
   * Loading all the projects for the dashboard
   */
  static async load(){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/project/",
        method: "GET",
        params: {
          _console_token: UserSession.token
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Retrieves a single project.
   * @param {number} id The ID of a project, which should be retrieved.
   */
  static async get(id){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/project/",
        method: "GET",
        params: {
          _console_token: UserSession.token,
          id: id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Creates a new project.
   * @param {string} name A new name for a new project.
   */
  static async create(name){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/project/",
        method: "POST",
        data: {
          _console_token: UserSession.token,
          name: name
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Updates an existing project.
   * @param {number} id The project ID, which should be updated.
   * @param {string} name A new name for the project.
   * @param {string} description A optional description for the project.
   */
  static async edit(id, name, description){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/project/",
        method: "PUT",
        data: {
          _console_token: UserSession.token,
          id: id,
          name: name,
          description: description
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Deletes an project and all the associations to it, inclusively the data.
   * @param {number} id The project ID, which should be deleted.
   */
  static async delete(id){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/project/",
        method: "DELETE",
        data: {
          _console_token: UserSession.token,
          id: id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Publishes the given project.
   * @param {number} id The project ID, which should be deleted.
   */
  static async publish(id){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/project/",
        method: "PUT",
        data: {
          _console_token: UserSession.token,
          id: id,
          function: "publish"
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Unpublishes the given project.
   * @param {number} id The project ID, which should be deleted.
   */
  static async unpublish(id){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/project/",
        method: "PUT",
        data: {
          _console_token: UserSession.token,
          id: id,
          function: "unpublish"
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }
}
